<script>
import html2canvas from 'html2canvas'

export default {
  name: 'InfoSnapshot',
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    signatureUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    getSnapshot() {
      return new Promise((resolve, reject) => {
        const el = this.$refs.container
        el.style.display = 'block'
        this.$nextTick(() => {
          html2canvas(this.$refs.container).then(canvas => {
            el.style.display = 'none'
            canvas.toBlob(blob => {
              const f = new File([blob], Date.now() + '.png')
              let fd = new FormData()
              fd.append('file', f)
              resolve(fd)
            })
          }).catch(() => {
            el.style.display = 'none'
            reject()
          })
        })
      })
    },
  }
}
</script>

<template>
  <div style="opacity: 0">
    <div ref="container" style="width: 718px;padding: 20px; display: none;color: rgba(0,0,0,.85);">
      <div style="font-size: 18px;font-weight: 600;margin-bottom: 12px">
        <span>{{ title }}</span>
      </div>
      <div v-html="content"></div>
      <div style="margin-top: 12px;">
        <img :src="signatureUrl" alt="" width="718">
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
